var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarehouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 5.33332C14.3187 5.33366 14.2385 5.31541 14.1653 5.27999L8 2.13332L1.83467 5.25866C1.70312 5.32089 1.55224 5.32832 1.41521 5.27932C1.27818 5.23031 1.16624 5.12887 1.104 4.99732C1.04176 4.86578 1.03433 4.71489 1.08334 4.57787C1.13235 4.44084 1.23379 4.32889 1.36533 4.26666L8 0.981323L14.6347 4.26666C14.7745 4.29933 14.8959 4.38578 14.9724 4.50728C15.049 4.62878 15.0747 4.77555 15.0438 4.91581C15.0129 5.05608 14.9281 5.17854 14.8076 5.25668C14.6871 5.33483 14.5407 5.36236 14.4 5.33332V5.33332ZM5.33333 10.6667H2.13333V13.8667H5.33333V10.6667ZM9.6 10.6667H6.4V13.8667H9.6V10.6667ZM13.8667 10.6667H10.6667V13.8667H13.8667V10.6667ZM11.7333 6.39999H8.53333V9.59999H11.7333V6.39999ZM7.46667 6.39999H4.26667V9.59999H7.46667V6.39999Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.1d8fff64.svg";
export { ForwardRef as ReactComponent };